import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import logoSvg from '../../assets/logo.svg';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useLanguage();

  return (
    <footer className="footer">
      <div className="footer__top">
        <div className="footer__container">
          <div className="footer__brand">
            <Link to="/" className="footer__logo">
              <img src={logoSvg} alt="MahMedix" className="footer__logo-img" />
            </Link>
            <p className="footer__tagline">{t.footer.tagline}</p>
          </div>

          <div className="footer__links-group">
            <h4 className="footer__heading">{t.footer.navigation}</h4>
            <ul className="footer__links">
              <li><Link to="/">{t.nav.home}</Link></li>
              <li><Link to="/about">{t.nav.about}</Link></li>
              <li><Link to="/contact">{t.nav.contact}</Link></li>
              <li><Link to="/impressum">Impressum</Link></li>
            </ul>
          </div>

          <div className="footer__links-group">
            <h4 className="footer__heading">{t.footer.services}</h4>
            <ul className="footer__links">
              {t.footer.serviceList.map((service, i) => (
                <li key={i}><span>{service}</span></li>
              ))}
            </ul>
          </div>

          <div className="footer__links-group">
            <h4 className="footer__heading">{t.footer.contact}</h4>
            <ul className="footer__contact-list">
              <li>
                <span className="footer__contact-icon">✉</span>
                <a href="mailto:info@mahmedix.de">info@mahmedix.de</a>
              </li>
              <li>
                <span className="footer__contact-icon">☎</span>
                <a href="tel:+4938344398063">(+49) 38344398063</a>
              </li>
              <li>
                <span className="footer__contact-icon">📍</span>
                <span>Ernst-Thälmann Ring 64a,<br />17491 Greifswald, Germany</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer__bottom">
        <div className="footer__container footer__bottom-inner">
          <p className="footer__copyright">
            © {currentYear} MahMedix. {t.footer.allRightsReserved}
          </p>
          <div className="footer__bottom-links">
            <Link to="/impressum">Impressum</Link>
            <Link to="/contact">{t.nav.contact}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
